import { ExtendedTabs, ExtendedTabsProps } from "../ExtendedTabs";
export const Tabs = ExtendedTabs;
export interface TabsProps extends ExtendedTabsProps {}
